
/* styles */
require("!!../node_modules/.1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/.10.3.0@vue-loader/lib/style-rewriter?id=data-v-87b82234!../node_modules/.1.2.8@vux-loader/src/style-loader.js!../node_modules/.10.3.0@vue-loader/lib/selector?type=styles&index=0!./App.vue")

var Component = require("!../node_modules/.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/.1.2.8@vux-loader/src/script-loader.js!../node_modules/.10.3.0@vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../node_modules/.10.3.0@vue-loader/lib/template-compiler?id=data-v-87b82234!../node_modules/.1.2.8@vux-loader/src/template-loader.js!../node_modules/.10.3.0@vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 245
// module chunks = 17